import { render, staticRenderFns } from "./OperationConfigDetailCatGather.vue?vue&type=template&id=684dd983&scoped=true"
import script from "./OperationConfigDetailCatGather.vue?vue&type=script&lang=js"
export * from "./OperationConfigDetailCatGather.vue?vue&type=script&lang=js"
import style0 from "./OperationConfigDetailCatGather.vue?vue&type=style&index=0&id=684dd983&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684dd983",
  null
  
)

export default component.exports